<template>
    <div>
        <el-tabs v-model="cur" @tab-click="handleClick">
            <el-tab-pane label="企业" name="1"></el-tab-pane>
            <el-tab-pane label="导师" name="2"></el-tab-pane>
        </el-tabs>
        <div class="ordersContent">
            <div class="itesm flx alc jsb cursor" v-for="item,index in list" @click="toDetail(item)">
                <div class="flx alc">
                    <div class="itsImg">
                        <img :src="$img(item.avatar)" alt="" />
                    </div>
                    <div class="itsName" v-text="item.name"></div>
                </div>
                <div class="itsRight cursor">
                    已关注
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getFocusList
    } from "@/api/index.js"
    export default {
        name: 'Order',
        data() {
            return {
                cur: "1",
                list: []
            }
        },
        mounted() {
            this.getList()
        },
        methods: {
            toDetail(e){
                if(this.cur == 1){
                    this.$router.push({
                        path: '/Companyhr', // 写路由path
                        query: {
                            id:e.shop_id
                        }
                    })
                   
                }else{
                   this.$router.push({
                       path: '/coachDetail', // 写路由path
                       query: {
                           id:e.mentor_id
                       }
                   })
                }
            },
            handleClick(e) {
                let that = this
                that.cur = e.name
                that.getList()
                console.log(e)
            },
            getList() {
                let that = this
                let data = that.cur
                getFocusList(data).then((res) => {
                    console.log("books", res)
                    if (res.code == 1) {
                        that.list = res.data
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .itsRight{
        width: 68px;
        height: 24px;
        background: #F3F3F4;
        border-radius: 3px;
        text-align: center;
        line-height: 24px;
        font-weight: 500;
        font-size: 12px;
        color: #161823;
    }
    .itsName{
        font-weight: 500;
        font-size: 14px;
        color: #161823;
    }
    .itsImg{
        width: 58px;
        height: 58px;
        margin-right: 12px;
        width:100%;
        overflow-y: hidden;
    }
    .itsImg img{
        width: 100%;
        border-radius: 50%;
    }
    .ordersContent{
        box-sizing: border-box;
        padding: 0 30px;
    }
    .itesm{
        width: 100%;
        padding: 20px 0;
        border-bottom: 1px solid #eaeaea;
    }
</style>